import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { FundingSourceRepository } from '@/store/funding-source-state/funding-source-state.repository';

interface getFundingSourceUpdateDrawerObjectProps {
  store: FundingSourceRepository;
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getFundingSourceUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: getFundingSourceUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'fundingSources.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: { formObject },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.update',
        onClick: () => action?.(),
      },
      {
        label: 'common.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
